import TheGrid from '@/views/dealers/teams/grid'
import TheGridManagers from '@/views/dealers/teams/gridmanagers'
import Edit from '@/views/dealers/teams/edit'

export default {
  path: '/dealers/teams',
  redirect: '/dealers/teams/index',
  name: 'teams',
  meta: {
    auth: {
      redirect: {
        name: 'teams.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Equipas'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'teams.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'managers',
    name: 'teams.managers',
    component: TheGridManagers,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'create',
    name: 'teams.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'teams.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
